interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'h-4 w-4 border-2',
  md: 'h-8 w-8 border-4',
  lg: 'h-12 w-12 border-4',
};

export function LoadingSpinner({ size = 'md', className = '' }: LoadingSpinnerProps) {
  const sizeClass = sizeClasses[size];
  
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div 
        role="status"
        className={`${sizeClass} border-brand-200 border-t-brand-600 rounded-full animate-spin shadow-glow ${className}`}
        aria-label="Loading"
      />
    </div>
  );
}
